var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-content"},[_c('h1',{staticClass:"error-code"},[_vm._v("404")]),_c('p',{staticClass:"error-message"},[_vm._v("Oops! Page not found.")]),_c('a',{staticClass:"back-home-btn",attrs:{"href":"/"}},[_vm._v("Go Back Home")])])])
}]

export { render, staticRenderFns }